import intl from 'preact-i18n';
import definition from './intl.json';
function intlWrap(c) { return intl(c, { scope: 'blocks', definition }); }

import _TertiaryNav from './components/tertiary-nav';
export const TertiaryNav = intlWrap(_TertiaryNav);

// Note: In order to be able to spy/stub these components in other modules, the import and export must be separate statements
// export {default as Nav} from './components/nav'
// results in an un-wrappable function (because babel creates an accessor property instead of a data property on the export)

import Nav, { isCurrent as navItemIsCurrent, getSubnav } from './components/nav';
export { Nav, navItemIsCurrent, getSubnav };

import scrollDirection, { ScrollDirection } from './components/scrolldirection';
export { scrollDirection, ScrollDirection };

import Icon  from './components/icon';
export { Icon };

import Header  from './components/header';
export { Header };

import HeaderV2  from './components/headerv2';
export { HeaderV2 };

import Spinner from './components/spinner';
export { Spinner };

import { InputText } from './components/input-text';
export { InputText };

import { OverlayInputText } from './components/overlay-input-text';
export { OverlayInputText };

import { Select, Option } from './components/select';
export { Select, Option };

import ClickOutsideDetector from './components/click-outside-detector';
export { ClickOutsideDetector };

import ViewportScrollDetector from './components/viewport-scroll-detector';
export { ViewportScrollDetector };

import Swipeable from './components/swipeable';
export { Swipeable };

import Dialog, { ModalDialog, FixedDialog, ContentDialog } from './components/dialog';
export { Dialog, ModalDialog, FixedDialog, ContentDialog };

import Popover from './components/popover';
export { Popover };

import Carousel from './components/carousel';
export { Carousel };

import DeviceVariance, { deviceVariance, isDeviceType, DEVICE_TYPE_PHONE, DEVICE_TYPE_PHONE_PORTRAIT, DEVICE_TYPE_PHONE_LANDSCAPE, DEVICE_TYPE_TABLET, DEVICE_TYPE_DESKTOP, DEVICE_TYPE_DESKTOP_LARGE, DEVICE_TYPE_GROUP_MOBILE, DEVICE_TYPE_GROUP_DESKTOP } from './components/device-variance';
export { DeviceVariance, deviceVariance, isDeviceType, DEVICE_TYPE_PHONE, DEVICE_TYPE_PHONE_PORTRAIT, DEVICE_TYPE_PHONE_LANDSCAPE, DEVICE_TYPE_TABLET, DEVICE_TYPE_DESKTOP, DEVICE_TYPE_DESKTOP_LARGE, DEVICE_TYPE_GROUP_MOBILE, DEVICE_TYPE_GROUP_DESKTOP };

import ContainerSize, { containerSize } from './components/container-size';
export { ContainerSize, containerSize };

import RenderOnVisible from './components/render-on-visible';
export { RenderOnVisible };

import Tabs, { Tab } from './components/tabs';
export { Tabs, Tab };

import Button from './components/button';
export { Button };

import FormattedTime from './components/formatted-time';
export { FormattedTime };

import RelativeTime, { RelativeTimeUpdatable } from './components/relative-time';
export { RelativeTime, RelativeTimeUpdatable };

import Truncate from './components/truncate';
export { Truncate };

import SafeAnchor from './components/safe-anchor';
export { SafeAnchor };

import Accordion from './components/accordion';
export { Accordion };

import Sticky from './components/sticky';
export { Sticky };

import StyleJail from './components/style-jail';
export { StyleJail };

import TouchMouseEmulator from './components/touch-mouse-emulator';
export { TouchMouseEmulator };
